import { render, staticRenderFns } from "./EvaluateeEvaluationsListView.vue?vue&type=template&id=620b0466&scoped=true"
import script from "./EvaluateeEvaluationsListView.vue?vue&type=script&lang=js"
export * from "./EvaluateeEvaluationsListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620b0466",
  null
  
)

export default component.exports